import { css } from 'emotion'

export const CheveronRightIconStyles = css`
  transform: rotate(180deg);
`
